export default __webpack_public_path__ + "static/media/logo-white.53b25be9.svg";